import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
export const SectionsWrapper = ({ children, testId }) => (_jsx(Box, { width: "100%", display: "flex", flexDirection: "column", testId: testId, backgroundColor: "color.background.constant.white", borderRadius: "radius.16", marginTop: {
        "breakpoint.base": "-spacing.16",
        "breakpoint.lg": "unset",
    }, paddingTop: {
        "breakpoint.base": "spacing.16",
        "breakpoint.lg": "unset",
    }, paddingRight: {
        "breakpoint.base": "spacing.none",
        "breakpoint.xxxl": "spacing.128",
    }, position: "relative", children: children }));
